import styled from 'styled-components'

export interface MenuPlacement {
  direction: 'top' | 'bottom'
  offset: number
}

interface MenuUiProps {
  placement: MenuPlacement
}
export const ToolbarEditorUi = styled.div<MenuUiProps>`
  display: flex;
  position: absolute;
  ${({ placement }) => `${placement.direction}: ${placement.offset}px`};
  flex-wrap: wrap;
  z-index: 20;
  left: -2px;
  background-color: rgb(20, 158, 252);
  border-radius: 5px 5px 0px 0px;
  width: calc(100% + 4px);
`
